module.exports = __webpack_public_path__ + "static/media/reward.4a6b3595.svg";